import { render, staticRenderFns } from "./FileManagerForm.vue?vue&type=template&id=483b9451&scoped=true&"
import script from "./FileManagerForm.vue?vue&type=script&lang=ts&"
export * from "./FileManagerForm.vue?vue&type=script&lang=ts&"
import style0 from "./FileManagerForm.vue?vue&type=style&index=0&id=483b9451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b9451",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VFileInput,VRow})
